import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from './actions';
import Const from 'constants';
import TeamStack from './components/team-stack';

class MLBHittersStack extends Component {
    useFilter(use) {
        this.props.dispatch(Action.useHitterStack(!use));
    }

    setStackMode(isDouble) {
        this.props.dispatch(Action.setHittersDoubleStackMode(isDouble));
    }

    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isReady() && sportConfig.getConfigProp('useLegacyControlledHitterStacking', false);
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return false;
        }

        const {stack} = this.props;

        return (
            <div className={`advanced-filter${stack.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.useFilter(stack.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable Legacy Controlled Hitter Stacks
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.useFilter(stack.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Enable Legacy Controlled Hitter Stacks
                    </button>
                </div>

                <div className="white-box">
                    <h2 className="mb15">Hitter Stack Rules</h2>
                    <div className="checkbox mb20">
                        <label>
                            <input
                                type="checkbox"
                                checked={stack.isDoubleStackModeEnabled()}
                                onChange={(e) => ::this.setStackMode(e.target.checked)}
                            />
                            Double stacking
                        </label>
                    </div>
                    <div className="team-filter">
                        <TeamStack groupNumber={Const.FIRST_HITTER_GROUP} />
                        {stack.isDoubleStackModeEnabled() ? (
                            <TeamStack groupNumber={Const.SECOND_HITTER_GROUP} />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {games, filters: playersFilter} = state.playersData;
    const {sportConfig, stacks} = state;

    return {
        games,
        sportConfig,
        playersFilter,
        stack: stacks.hitters,
    };
}

export default connect(mapStatesToProps)(MLBHittersStack);
